export default "__VITE_ASSET__CgTFE1tP__"